import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUserStr = sessionStorage.getItem("currentUser");
    const usuario = sessionStorage.getItem("usuario");
    const apiBaseUrl: string = environment.baseUrl.replace(/\/+$/, "");
    const maintenanceBaseUrl: string = (
      (environment as { maintenanceBaseUrl?: string }).maintenanceBaseUrl ?? environment.baseUrl
    ).replace(/\/+$/, "");
    const shouldAttachApiKey: boolean =
      !!environment.apiKey
      && (request.url.startsWith(apiBaseUrl) || request.url.startsWith(maintenanceBaseUrl));

    if (shouldAttachApiKey) {
      request = request.clone({
        setHeaders: {
          "X-Api-Key": environment.apiKey,
        },
      });
    }

    if (currentUserStr) {
      try {
        const currentUser = JSON.parse(currentUserStr);

        if (currentUser && currentUser.token) {
          request = request.clone({
            setHeaders: {
              ...(shouldAttachApiKey ? { "X-Api-Key": environment.apiKey } : {}),
              Authorization: `Bearer ${currentUser.token}`,
              Iduser: usuario || "",
            },
          });
        }
      } catch (error) {
        console.error("Error al parsear currentUser del sessionStorage:", error);
      }
    }

    return next.handle(request);
  }
}
